import { language } from "language/default";
const getSeriesName = (items, field) => {
    const [first] = items || [];
    if (first) {
        if (first.measures?.[field]) {
            return first.measures[field]?.toString() ?? "";
        }
        if (first.data) {
            return getSeriesName(first.data, field);
        }
    }
    return "";
};
const getCategoriesMap = (items, label) => {
    const result = new Map();
    if (label?.length) {
        for (const item of items) {
            if (item.dimension && item.measures?.[label]) {
                const key = item.dimension.toString();
                const value = item.measures[label]?.toString() ?? key;
                result.set(key, value);
            }
            if (item.data?.length) {
                const subCategories = getCategoriesMap(item.data, label);
                for (const [key, value] of subCategories) {
                    result.set(key, value);
                }
            }
        }
    }
    return result;
};
const getCategoryName = (map, series) => {
    const name = series.name === undefined ? "" : series.name.toString();
    if (name) {
        const mapped = map.get(name);
        return mapped || name;
    }
    return "";
};
const mapSeriesWithCategory = (categoriesMap, series, title) => {
    const name = getCategoryName(categoriesMap, series);
    const { custom } = series;
    if (custom && Array.isArray(custom.tooltip) && custom.metadata?.tooltipLabels && custom.metadata.tooltipLabels.length > 1) {
        const [, dimensionLabelConfig] = custom.metadata.tooltipLabels;
        const dimensionLabel = dimensionLabelConfig?.label;
        if (dimensionLabel) {
            const updatedTooltip = custom.tooltip.map((pair) => {
                const [label, value] = pair;
                return label === dimensionLabel
                    ? [label, name || value]
                    : [label, value];
            });
            return {
                ...series,
                custom: { ...custom, tooltip: updatedTooltip },
                name,
                title
            };
        }
    }
    return {
        ...series,
        name,
        title,
        ...custom ? { custom } : {}
    };
};
export const mapSeriesWithCategoryForTests = mapSeriesWithCategory;
export const groupHighchartsOneMeasure = (seriesName, categoriesLabel) => (args) => {
    const aliases = args.context.request ? [args.context.request.entityAlias, ...args.context.request.comparates.map((c) => c.alias)] : [], categoriesMap = getCategoriesMap(args.context.staticData.root.flatMap((r) => r.items), categoriesLabel);
    const entities = args.context.staticData.root.filter((r) => aliases.includes(r.entityAlias));
    const [diff] = args.context.staticData.root.find((r) => !entities.includes(r))?.customResult?.map((c) => ({
        ...c,
        metaData: { ...c.metaData, isDifference: true },
        series: c.series.map((s) => mapSeriesWithCategory(categoriesMap, s, language.en.widget.difference))
    })) || [{ metaData: {}, series: [] }];
    args.context.staticData.customResult = entities.flatMap((e) => e.customResult?.map((c) => ({
        ...c,
        series: c.series.map((s) => mapSeriesWithCategory(categoriesMap, s, getSeriesName(e.items, seriesName)))
    })) || []).concat([diff]);
    for (const series of args.context.staticData.customResult) {
        const categories = series.series.map((s) => s.name);
        for (const other of args.context.staticData.customResult.filter((r) => r !== series && r.series.length)) {
            const [toClone] = other.series;
            const otherCats = other.series.map((s) => s.name);
            for (const cat of categories.filter((c) => !otherCats.includes(c))) {
                other.series.push({ name: cat, title: toClone.title, type: toClone.type, y: 0 });
            }
        }
    }
    const differenceIndex = args.context.staticData.customResult.indexOf(diff);
    const additionalDatas = entities.map((x) => x.items?.[0]?.additionalData), diffAdditionalData = args.context.staticData.root?.[differenceIndex]?.items?.[0]?.additionalData;
    args.context.staticData.additionalData = {
        differenceIndex,
        max: [Math.max(...additionalDatas.map((y) => y?.max ?? 0)), diffAdditionalData?.max],
        min: [Math.min(...additionalDatas.map((y) => y?.min ?? 0)), diffAdditionalData?.min]
    };
};
